import React, { useState, useEffect, useCallback } from "react";
import TablePagination from "@mui/material/TablePagination";
import { useLocation, useNavigate } from "react-router-dom";
import TableContainer from "@mui/material/TableContainer";
import { apiCall } from "../services/authServieces";
import ShowSnackBar from "../components/snackBar";
import SearchIcon from "@mui/icons-material/Search";
import Search from "../Assets/images/search.png";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import "../css/manage_waba.css";
import "../css/wb_report_details.css";
import { formatDate } from "../utils/helper";
import { ClipLoader } from "react-spinners";
import { useUIContext } from "../context";
import CustomDateRangePicker from "../components/CustomDatePicker";

import excelIcon from "../Assets/images/excel.png"


const UserTemplateReport = () => {


    

  const user = JSON.parse(localStorage.getItem('user-cred'));

    let userId=user.user.userId;

    const [loading, setLoading] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [snackBar, setSnackBar] = useState({
        open: false,
        severity: "success",
        message: "",
    });
    const location = useLocation();
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const rowData = location.state?.rowData;
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState(searchTerm);
    const navigate = useNavigate();


    const columns = [
        // { id: "template_id", label: "Template Id", minWidth: 100 },
        { id: "template_name", label: "Template Name", minWidth: 100 },
        { id: "type", label: "Template Type", minWidth: 100 },
        { id: "category", label: "Category", minWidth: 100 },
        { id: "template_count", label: "Total Whatsapp", minWidth: 100 },
       
        { id: "user_count", label: "User Count", minWidth: 100 }
    ];

    const [rows, setRows] = useState([]);
    const [total, setTotal] = useState(0);
    const { dateRanges } = useUIContext();
    const dates = dateRanges.mis.map(date => {
        if (!date) return undefined;

        const localDate = new Date(date);
        const year = localDate.getFullYear();
        const month = String(localDate.getMonth() + 1).padStart(2, "0");
        const day = String(localDate.getDate()).padStart(2, "0");

        return `${year}-${month}-${day}`;
    });

    const [startDate, endDate] = dates;
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };


    const handleExportTemplateOverview = async () => {
          setLoading(true);
  try {
    const user = JSON.parse(localStorage.getItem("user-cred"));
    const token = user?.token;
    const baseURL = process.env.REACT_APP_API_URL;

    let endpoint = `${baseURL}/api/reports/download-template-overview-report`;

    const params = new URLSearchParams();
    if (startDate && endDate) {
      params.append("startDate", startDate);
      params.append("endDate", endDate);
    }
    if (debouncedSearchTerm) {
      params.append("search", debouncedSearchTerm);
    }

    endpoint = `${endpoint}?${params.toString()}`;

    const response = await fetch(endpoint, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) throw new Error("Failed to export Template Overview Report");

    const blob = await response.blob();

    let filename = "Template_Overview_Report.csv";
    const disposition = response.headers.get("Content-Disposition");
    if (disposition) {
      const match = disposition.match(/filename="?([^"]+)"?/);
      if (match && match[1]) filename = decodeURIComponent(match[1]);
    }

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    setSnackBar({
      open: true,
      severity: "success",
      message: "Template Overview Report downloaded successfully",
    });
  } catch (error) {
    console.error(error);
    setSnackBar({
      open: true,
      severity: "error",
      message: "Failed to download Template Overview Report",
    });
  }finally{
      setLoading(false);
  }
};

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    const handleCloseSnackBar = (event, reason) => {
        setSnackBar((prevState) => ({ ...prevState, open: false }));
    };

    const handleRowClick = (row) => {
        const templateId = row?.template_id;
        navigate(`/template_report/${templateId}`, { state: { rowData: row } });
    };

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearchTerm(searchTerm);
        }, 500);

        return () => {
            clearTimeout(handler);
        };
    }, [searchTerm]);

    const handleDateClick = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            let endpoint ;
             if(userId=='hondasalesapi'){

                  let salesTemplateId="899620655733524,1785128478778560,939592869132697,1334795734860104"
            endpoint = `api/reports/get-template-overview-report-templatewise?page=${page + 1}&limit=${rowsPerPage}&startDate=${startDate}&endDate=${endDate}&templateIds=${salesTemplateId}`;

             }else{

                 endpoint = `api/reports/get-template-overview-report?page=${page + 1}&limit=${rowsPerPage}&startDate=${startDate}&endDate=${endDate}`;


             }

            const response = await apiCall({ endpoint: endpoint, method: 'GET' });
            if (response.success) {
                setRows(response.data);
                setTotal(response.total);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearchTerm(searchTerm);
        }, 500);

        return () => {
            clearTimeout(handler);
        };
    }, [searchTerm]);

    
   
  

    const fetchData = useCallback(async () => {
        setLoading(true);
        try {
             let endpoint;

             if(userId=='hondasalesapi'){
                let salesTemplateId="899620655733524,1785128478778560,939592869132697,1334795734860104"

               endpoint = `api/reports/get-template-overview-report-templatewise?page=${page + 1}&limit=${rowsPerPage}&templateIds=${salesTemplateId}`;

            if (startDate && endDate) {
                endpoint = `${endpoint}&startDate=${startDate}&endDate=${endDate}`;
            }
            if (debouncedSearchTerm) {
                endpoint = `${endpoint}&search=${debouncedSearchTerm}`;
            }


             }

            else{

            endpoint = `api/reports/get-template-overview-report?page=${page + 1}&limit=${rowsPerPage}`;

            if (startDate && endDate) {
                endpoint = `${endpoint}&startDate=${startDate}&endDate=${endDate}`;
            }
            if (debouncedSearchTerm) {
                endpoint = `${endpoint}&search=${debouncedSearchTerm}`;
            }

        }


            const response = await apiCall({ method: "GET", endpoint: endpoint });
            if (response.success) {
                setRows(response.data);
                setTotal(response.total);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    }, [page, rowsPerPage, rowData?.created_by, debouncedSearchTerm]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };

    return (
        <>
            <div className="Template_id_contian">
                <h4 className="Head_title MisReportTitle">
                    <div className="DateRangeContain">
                        <CustomDateRangePicker rangeKey="mis" /><button type="button" className="SearchDateRange" onClick={handleDateClick}><img src={Search} alt="Search" /></button>
                    </div>
                    Template Report
                    <div className="Session_report_SearchContain search_btn_in">
                        <div>
                            <input
                                placeholder="Search"
                                type="text"
                                className=""
                                value={searchTerm}
                                onChange={handleSearchChange}
                            />
                           
                        </div>
                    </div>
                    <button type="button" className="ExcelIconContain add_btn7" onClick={() => { }}>
                        <img src={excelIcon} alt="excelIcon" className="ExcelIcon" />
                    </button>


  <button type="button" className="ExcelIconContain add_btn7" onClick={handleExportTemplateOverview}>
              <img src={excelIcon} alt="excelIcon" className="ExcelIcon" />
            </button>
                </h4>
                {/* <h4 className="Head_title AdminSearchContain DailyReport">
          <div className="TodayDeliveryRepot">
          {getCurrentDateInIST()}

          </div>
          Mis Report
          <div className="Session_report_SearchContain">
            <input
              placeholder="Search"
              type="text"
              className=""
              value={searchTerm}
              onChange={handleSearchChange}
            />
            <button type="button">
              <SearchIcon />
            </button>
          </div>
        </h4> */}

                <Paper sx={{ width: "100%", overflow: "hidden" }}>
                    <TableContainer sx={{ maxHeight: 440 }}>
                        <Table stickyHeader aria-label="sticky table" className="Table DailyReportTable">
                            <TableHead>
                                 <TableRow>
    {columns
      .filter(column => {
        if (column.user_count === 'type') {
          return userId === 'hondasalesapi'; // only allow for this user
        }
        return true; 
      })
      .map(column => (
        <TableCell
          key={column.id}
          align={column.align}
          style={{ minWidth: column.minWidth }}
        >
          {column.label}
        </TableCell>
      ))}
  </TableRow>
                            </TableHead>
                            <TableBody>
                                {rows && rows.map((row) => (
                                    <TableRow
                                        hover
                                        role="checkbox"
                                        tabIndex={-1}
                                        key={row.userId}
                                        onClick={() => handleRowClick(row)}
                                        style={{ cursor: "pointer" }} // Adds a pointer cursor to indicate clickable rows
                                    >
                                        {columns.map((column) => {
                                            const value = row[column.id];
                                            return <TableCell key={column.id}>{value}</TableCell>;
                                        })}
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <TablePagination
                        rowsPerPageOptions={[10, 25, 100]}
                        component="div"
                        count={total}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </Paper>
            </div>

            {loading && (
                <div className="spinnerOverlay">
                    <ClipLoader loading={loading} size={50} />
                </div>
            )}
            <ShowSnackBar
                open={snackBar.open}
                severity={snackBar.severity}
                message={snackBar.message}
                onClose={handleCloseSnackBar}
            />
        </>
    );
};



export default UserTemplateReport;
